import { useQuery } from "@tanstack/react-query";
import api from "../lib/apiClient";

export const useLeaderboard = () => {
	return useQuery({
		queryKey: ["leaderboard"],
		queryFn: async () => {
			const { data } = await api.get("/leaderboard");
			return data;
		},
	});
};